var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighRiskGroupsCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dhssxr6k7a",
    d: "M0 0h14.46v3.89H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.222 5.003a2.22 2.22 0 0 0-2.149 2.22v1.11c.004.537.201 1.054.555 1.456-.172.088-.336.191-.488.31l-.002-.004c.148-.117.308-.22.477-.306a2.224 2.224 0 0 1-.555-1.455v-1.11a2.222 2.222 0 0 1 2.162-2.221M17.686 17.07a9.992 9.992 0 0 1-9.652 2.588 9.994 9.994 0 0 1-4.48-2.587.559.559 0 0 1 .788-.789 8.885 8.885 0 0 0 6.278 2.6 8.873 8.873 0 0 0 6.277-2.6.558.558 0 0 1 .789.789",
    fill: "#AEB3B7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.39)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "x61jvx1plb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dhssxr6k7a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.296 3.718a.555.555 0 0 0 0-.789 9.99 9.99 0 0 0-14.132 0 .555.555 0 0 0 0 .79c.106.11.252.172.405.171.148.001.29-.057.395-.16a8.877 8.877 0 0 1 12.555 0 .555.555 0 0 0 .777-.012z",
    fill: "#AEB3B7",
    mask: "url(#x61jvx1plb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.61 12.5v1.388a.555.555 0 0 1-.554.556h-2.93l-2.206-4.157a2.974 2.974 0 0 1 .708-.498 2.225 2.225 0 0 1-.555-1.455v-1.11a2.222 2.222 0 0 1 2.28-2.221 2.22 2.22 0 0 1 2.148 2.22v1.11a2.225 2.225 0 0 1-.556 1.456 3.018 3.018 0 0 1 1.216 1.12c.294.478.45 1.03.45 1.59",
    fill: "#AEB3B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.514 8.334a2.224 2.224 0 0 1-.555 1.455c.169.086.328.189.477.306l-.002.003a3.018 3.018 0 0 0-.489-.309c.355-.402.552-.919.556-1.455v-1.11a2.222 2.222 0 0 0-2.149-2.221 2.222 2.222 0 0 1 2.162 2.22v1.11zM3.869 5.003a2.22 2.22 0 0 0-2.148 2.22v1.11c.003.537.2 1.054.555 1.456-.173.088-.337.191-.488.31l-.003-.004c.149-.117.309-.22.477-.306a2.224 2.224 0 0 1-.555-1.455v-1.11A2.222 2.222 0 0 1 3.87 5.002",
    fill: "#AEB3B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.799 10.894-1.885 3.55H1.165a.553.553 0 0 1-.554-.556V12.5a3.039 3.039 0 0 1 1.665-2.71 2.225 2.225 0 0 1-.555-1.456v-1.11a2.222 2.222 0 0 1 2.278-2.221 2.22 2.22 0 0 1 2.149 2.22v1.11a2.225 2.225 0 0 1-.555 1.456 3.018 3.018 0 0 1 1.206 1.105",
    fill: "#AEB3B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.161 8.334a2.224 2.224 0 0 1-.555 1.455c.169.086.329.189.477.306l-.002.003a3.018 3.018 0 0 0-.488-.309c.354-.402.551-.919.555-1.455v-1.11a2.222 2.222 0 0 0-2.149-2.221 2.222 2.222 0 0 1 2.162 2.22v1.11zM11.02 12.53l-.917-3.063h1.836l-.918 3.063zm0 1.837a.612.612 0 1 1 0-1.224.612.612 0 0 1 0 1.224zm.541-8.151a.612.612 0 0 0-1.08 0L5.99 14.674a.612.612 0 0 0 .54.9h8.981a.612.612 0 0 0 .54-.9l-4.49-8.458z",
    fill: "#AEB3B7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRiskGroupsCs);
export default __webpack_public_path__ + "static/media/high-risk-groups-cs.4f6f1f93.svg";
export { ForwardRef as ReactComponent };